import {CATALOGOS_TYPES} from '../constants/catalogos.types'
import {CatalogoAction, CatalogoState} from '../interfaces/catalogos.interface'

const initialState: CatalogoState = {
  planFacturas: [],
  tipoDocumento: [],
  tipoDocumentosEmision: [],
  departamentos: [],
  municipios: [],
  tipoEstablecimientos: [],
  actividadesEconomicas: [],
  condicionOperacion: [],
  tipoPersona	: [],
  datosEmisor: {},
  botonesAyuda: null,
  unidadesMedida: [],
  impuestosProducto: [],
  formasPago: [],
  condicionesPago: [],
  plazosPago: [],
  bancos: [],
  serviciosAdicionales: [],
  tipoCargosMembresia: [],
  productos: [],
}

const catalogoReducer = (state: CatalogoState = initialState,action: CatalogoAction): CatalogoState => {
  switch (action.type) {
    case CATALOGOS_TYPES.CATALOGO_SET_DEPARTAMENTOS: return {...state, departamentos: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_MUNICIPIOS: return {...state, municipios: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_TIPO_PERSONA: return {...state, tipoPersona: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_PLANFACTURAS: return {...state, planFacturas: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_ACTIVIDADES_ECONOMICAS: return {...state, actividadesEconomicas: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_TIPO_ESTABLECIMIENTOS: return {...state, tipoEstablecimientos: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_TIPO_DOCUMENTO: return {...state, tipoDocumento: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_TIPO_DOCUMENTOS_EMISION: return {...state, tipoDocumentosEmision: action.payload}
    case CATALOGOS_TYPES.GENERAL_DATOS_EMISOR: return {...state, datosEmisor: {...state.datosEmisor, ...action.payload}}
    case CATALOGOS_TYPES.CATALOGO_SET_BOTONES_AYUDA: return {...state, botonesAyuda: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_CONDICION_OPERACION_CAT016: return {...state, condicionOperacion: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_UNIDADES_MEDIDA: return {...state, unidadesMedida: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_IMPUESTOS: return {...state, impuestosProducto: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_CONDICIONES_PAGO: return {...state, condicionesPago: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_FORMAS_PAGO: return {...state, formasPago: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_PLAZOS_PAGO: return {...state, plazosPago: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_BANCOS: return {...state, bancos: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_SERVICIOS_ADICIONALES: return {...state, serviciosAdicionales: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_TIPO_CARGOS_MEMBRESIA: return {...state, tipoCargosMembresia: action.payload}
    case CATALOGOS_TYPES.CATALOGO_SET_PRODUCTOS: return {...state, productos: action.payload}
    case CATALOGOS_TYPES.CATALOGOS_CLEAR: return {...initialState, botonesAyuda: state.botonesAyuda}
    default: return state
  }
}

export default catalogoReducer
